import { render, staticRenderFns } from "./BaseInfoIcon.vue?vue&type=template&id=5301b4d4&scoped=true"
import script from "./BaseInfoIcon.vue?vue&type=script&lang=js"
export * from "./BaseInfoIcon.vue?vue&type=script&lang=js"
import style0 from "./BaseInfoIcon.vue?vue&type=style&index=0&id=5301b4d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5301b4d4",
  null
  
)

export default component.exports